var exports = {
  "q": "footer__NOcJuq",
};

module.exports = exports;
